/** Maximum seconds between confirmed photos before the session must be restarted. */
export const PHOTO_GAP_TIMEOUT_SECONDS = 10 * 60;
